/**
 * @file 通知相关接口
 * @author zhanghaohan
 */
import 'whatwg-fetch';
import {spyRequest as request} from '../log/index';
import API from './api';

/**
 * 获取未读消息数
 * @returns Promise
*/
export const getUnreadNoticeCount = async params => {
    return request(
        API.GET_UNREAD_COUNT, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 获取通知列表
 * @returns Promise
*/
export const getNoticeList = async params => {
    return request(
        API.GET_NOTICE_LIST, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 获取轮播公告列表
 * @returns Promise
*/
export const getNoticeCarouselList = async params => {
    return request(
        API.GET_NOTICE_CAROUSEL_LIST, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 轮播公告 中 协议内容
 * @returns Promise
*/
export const getAgreementContent = async params => {
    return request(
        API.GET_AGREEMENT_CONTENT, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 轮播公告 中 操作协议
 * @returns Promise
*/
export const agreementAction = async params => {
    return request(
        API.AGREEMENT_ACTION, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 获取通知列表
 * @returns Promise
*/
export const getNoticePopList = async params => {
    return request(
        API.GET_NOTICE_POP_LIST, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 通知设为已读
 * @returns Promise
*/
export const readNotice = async params => {
    return request(
        API.READ_NOTICE, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 删除通知
 * @returns Promise
*/
export const delNotice = async params => {
    return request(
        API.DEL_NOTICE, {
            method: 'POSTJSON',
            body: params
        }
    );
};
